import React, { useState } from "react";
import { useT } from "@/i18n/LanguageContext";
import DepotMap from "./DepotMap";

const Logistics = () => {
  const { t } = useT();
  const [active, setActive] = useState(0);

  return (
    <section id="logistics" data-testid="logistics-section" className="relative py-24 md:py-32 bg-[#020C1B]">
      <div className="absolute inset-x-0 top-0 h-px bg-[#D4AF37]/20" />
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="mb-14 md:mb-16 max-w-4xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="hairline-crimson" />
            <span className="font-sans text-[11px] tracked uppercase text-[#D4AF37]" style={{ letterSpacing: "0.32em" }}>
              {t.logistics.eyebrow}
            </span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-bone leading-[1.05] mb-5" style={{ fontWeight: 500 }}>
            {t.logistics.h2a} <span className="text-[#D4AF37] italic">{t.logistics.h2b}</span>
          </h2>
          <p className="font-sans text-base md:text-lg text-steel leading-relaxed max-w-3xl">
            {t.logistics.sub}
          </p>
        </div>

        <DepotMap
          depots={t.logistics.depots}
          activeIndex={active}
          onSelect={setActive}
          labels={{
            node: t.logistics.node,
            active: t.logistics.active,
            mapTitle: t.logistics.eyebrow,
          }}
        />
      </div>
    </section>
  );
};

export default Logistics;
